// extracted by mini-css-extract-plugin
module.exports = {"section-title":"_1410bfd27b--section-title--8Y8ni"};